import { useContext } from "react";
import { ConversationDetailsContext } from "../../context";
import { ConversationTypeEnum } from "@coxauto-ui/cxm/communications/interfaces";
import { EmailMessageSendButton } from "./email-message-send-button";
import { TextMessageSendButton } from "./text-message-send-button";
import { PhoneMessageSendButton } from "./phone-message-send-button";

export interface MessageSendButtonProps {
  onMessageSendFailed: () => void;
  onMessageSendFailedSetMsg: (msg: string) => void;
  isTextAndNoPhoneNumber: boolean;
  isTextWithRepairOrderOnly: boolean;
}

export function MessageSendButton(props: MessageSendButtonProps) {
  const { currentConversationType } = useContext(ConversationDetailsContext);

  switch (currentConversationType) {
    case ConversationTypeEnum.EMAIL:
      return (
        <EmailMessageSendButton
          onMessageSendFailed={props.onMessageSendFailed}
          onMessageSendFailedSetMsg={props.onMessageSendFailedSetMsg}
        />
      );

    case ConversationTypeEnum.TEXT:
      return (
        <TextMessageSendButton
          isTextAndNoPhoneNumber={props.isTextAndNoPhoneNumber}
          isTextWithRepairOrderOnly={props.isTextWithRepairOrderOnly}
          onMessageSendFailed={props.onMessageSendFailed}
          onMessageSendFailedSetMsg={props.onMessageSendFailedSetMsg}
        />
      );

    case ConversationTypeEnum.PHONE:
      return (
        <PhoneMessageSendButton
          onMessageSendFailed={props.onMessageSendFailed}
          onMessageSendFailedSetMsg={props.onMessageSendFailedSetMsg}
        />
      );

    default:
      return null;
  }
}

export default MessageSendButton;
